/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSouscriptionRecapQuery = gql`
  query GetSouscriptionRecapQuery {
    getSouscriptionRecap_souscription_recap {
      offer {
 effectDate  
packs {
 id  
customerId  
granteeId  
externalId  
pricings {
 id  
isSelected  
moduleLabel  
level  
supplementaryCover  
prices {
 price  
defaultPrice  
} 
} 
commissions {
 rate  
} 
} 
code  
}
      isProjectEditable 
      status 
      customer {
 id  
firstName  
lastName  
birthName  
phones {
 internationalCode  
number  
isMobile  
} 
emails {
 value  
} 
addresses {
 fields  
city  
zipCode  
country  
} 
bankAccounts {
 ownerName  
bankName  
bic  
iban  
} 
socialSecurities {
 number  
key  
regime  
isCSS  
dateCSS  
isTeletransmission  
organismCode  
twinsRank  
} 
isTNS  
birthDate  
civility  
maritalStatus  
isDigitalContract  
CSPs {
 label  
externalId  
categoryCSPExternalId  
categoryLvl1CSPExternalId  
} 
finances {
 annualIncome  
} 
professionalStatus  
subscriptionStatus  
salesArea {
 country  
} 
}
      contacts {
 id  
firstName  
lastName  
role  
phones {
 internationalCode  
number  
isMobile  
} 
emails {
 value  
} 
bankAccounts {
 ownerName  
bankName  
bic  
iban  
debitDay  
debitFrequency  
type  
} 
}
      grantees {
 id  
type  
bankAccounts {
 ownerName  
bankName  
bic  
iban  
} 
birthDate  
civility  
firstName  
lastName  
birthName  
socialSecurities {
 number  
key  
regime  
isCSS  
dateCSS  
isTeletransmission  
organismCode  
twinsRank  
} 
CSPs {
 label  
externalId  
categoryCSPExternalId  
categoryLvl1CSPExternalId  
} 
attachedSocialSecurities {
 birthDate  
civility  
firstName  
lastName  
number  
type  
} 
isTNS  
}
      bankAccounts {
 ownerName  
bankName  
bic  
iban  
debitDay  
debitFrequency  
type  
}
      documentsToUpload {
 code  
source  
tag  
bundleTag  
option  
label  
featureName  
filePath  
}
      documentsToDownload {
 code  
source  
tag  
bundleTag  
option  
label  
featureName  
filePath  
}
      collectionNeeds {
 isDutyOfAdviceSkipped  
}
      guarantees {
 code  
parentCode  
type  
label  
legend  
isSelected  
values  
annualPrice  
monthlyPrice  
}
      signature {
 mode  
}
      monthlyPrice 
      monthlyPriceMadelin 
      annualPrice 
      annualPriceMadelin 
      pricingLevel 
      user {
 emails {
 value  
} 
firstName  
lastName  
}
      prices {
 EMPLOYEE {
 monthly {
 product  
option  
optionsDetail {
 name  
amount  
unit  
} 
} 
yearly {
 product  
option  
optionsDetail {
 name  
amount  
unit  
} 
} 
totalBudgetEstimate {
 monthly  
yearly  
} 
totalBudgetEstimateByCompany {
 monthly  
yearly  
} 
label  
unit  
} 
PARTNER {
 monthly {
 product  
option  
optionsDetail {
 name  
amount  
unit  
} 
} 
yearly {
 product  
option  
optionsDetail {
 name  
amount  
unit  
} 
} 
label  
unit  
} 
CHILD {
 monthly {
 product  
option  
optionsDetail {
 name  
amount  
unit  
} 
} 
yearly {
 product  
option  
optionsDetail {
 name  
amount  
unit  
} 
} 
label  
unit  
} 
FAMILY {
 monthly {
 product  
option  
optionsDetail {
 name  
amount  
unit  
} 
} 
yearly {
 product  
option  
optionsDetail {
 name  
amount  
unit  
} 
} 
totalBudgetEstimate {
 monthly  
yearly  
} 
totalBudgetEstimateByCompany {
 monthly  
yearly  
} 
label  
unit  
} 
DUO {
 monthly {
 product  
option  
optionsDetail {
 name  
amount  
unit  
} 
} 
yearly {
 product  
option  
optionsDetail {
 name  
amount  
unit  
} 
} 
label  
unit  
} 
}
      demography {
 childrenCount  
partnerCount  
employeeAverageAge  
employeeCount  
college  
employerPercentCount  
employerPercentShare  
tariffStructure  
socialSecurities {
 number  
key  
regime  
isCSS  
dateCSS  
isTeletransmission  
organismCode  
twinsRank  
} 
}
      company {
 name  
siret  
siren  
ccnId  
ccnName  
}
      formulaLevelLabel 
      tariffStructureLabel 
      companyContacts {
 decisionMaker {
 id  
firstName  
lastName  
role  
phones {
 internationalCode  
number  
isMobile  
} 
emails {
 value  
} 
bankAccounts {
 ownerName  
bankName  
bic  
iban  
debitDay  
debitFrequency  
type  
} 
} 
hr {
 id  
firstName  
lastName  
role  
phones {
 internationalCode  
number  
isMobile  
} 
emails {
 value  
} 
bankAccounts {
 ownerName  
bankName  
bic  
iban  
debitDay  
debitFrequency  
type  
} 
} 
}
      beneficiariesEnrollment 
      prevTnsCommission {
 rate  
type  
}
      jobs {
 caisse  
label  
value  
}
      canSendMail 
    }
  }
`;

export default GetSouscriptionRecapQuery;
